


















import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"
import {GetDlyOvertime, OperateDlyOverTime} from "@/api/dialysisProcess"
import AddOrEdit from './addOrEdit.vue'

@Component({
	components: {AddOrEdit}
})
export default class Roles extends AbpBase {
	loading = false
	showCheck = false
	showCancel = false
	data: any = []
	dates: any = []
	addOrEditShow = false
	addOrEditData: any = {}
	selectRow: any = []

	tableSelect(val: any) {
		if (val.length === 1) {
			this.data.forEach((item: any) => {
				if (item.isAudit !== val[0].isAudit) {
					item._disabled = true
				}
			})
		} else if (val.length === 0) {
			this.data.forEach((item: any) => {
				item._disabled = false
			})
		}
		this.selectRow = val
	}

	// 审核或取消审核
	async check(b: boolean) {
		let arr: any = []
		this.selectRow.forEach((item: any) => {
			if (item) arr.push(item.id)
		})
		if (!arr.length) {
			this.$Message.error("请先选择！")
			return
		}
		let res = await OperateDlyOverTime({ids: arr, isAudit: b})
		if (res.status === 1) {
			this.getData()
		}
	}

	// checkbox 值改变事件
	checked(val: boolean, p: any) {
		if (val) {
			if (p.row.isAudit) {
				this.showCancel = true
			} else {
				this.showCheck = true
			}
			this.selectRow[p.index] = p.row
			this.data.forEach((item: any, index: number) => {
				if (item.isAudit !== p.row.isAudit) {
					item._disabled = true;
					(this.$refs['check' + index] as any).disabled = true
				}
			})
		} else {
			this.selectRow[p.index] = null
			let num = 0
			this.selectRow.forEach((item: any) => {
				if (item) {
					num++
				}
			})
			if (!num) {
				this.showCheck = false
				this.showCancel = false
				this.data.forEach((item: any, index: number) => {
					(this.$refs['check' + index] as any).disabled = false
				})
			}
		}
	}

	columns = [
		{
			title: ' ',
			width: 50,
			align: 'center',
			render: (h: any, p: any) => {
				const vm = this
				const create = this.$createElement
				return create('Checkbox', {
					ref: 'check' + p.index,
					on: {
						'on-change': (val: boolean) => {
							vm.checked(val, p)
						}
					}
				})
			}
		},
		{
			title: "状态",
			width: 110,
			render: (h: any, p: any) => {
				return h('span', p.row.isAudit ? '已审核' : '未审核')
			}
		}, {
			title: "记录时间",
			render: (h: any, p: any) => {
				return h('span', this.formatDate(p.row.inputDate))
			}
		}, {
			title: "加班时间",
			width: 315,
			render: (h: any, p: any) => {
				return h('span', this.formatDateTime(p.row.startDate) + ' 至 ' + this.formatDateTime(p.row.endDate))
			}
		}, {
			title: "人员",
			key: 'dutyNurse'
		}, {
			title: "部门",
			key: 'depart'
		}, {
			title: "患者",
			key: 'patientName'
		}, {
			title: "白班时长",
			key: 'dayDuration'
		}, {
			title: "夜班时长",
			key: 'nightDuration'
		}, {
			title: "备注",
			key: 'remarks'
		}, {
			width: 100,
			title: "操作",
			render: (h: any, p: any) => {
				const vm = this
				return h("Button", {
					props: {
						type: 'primary'
					},
					style: {
						display: p.row.isAudit ? 'none' : 'inline-block'
					},
					on: {
						click() {
							vm.editOne(p.row)
						}
					}
				}, "编辑")
			}
		}
	]

	editOne(row: any) {
		this.addOrEditData = {
			mode: 'edit',
			data: row
		}
		this.addOrEditShow = true
	}

	formatDateTime(val: string) {
		if (val) {
			let arr = val.split('T')
			let arr1 = arr[1].split(':')
			return arr[0] + ' ' + arr1[0] + ':' + arr1[1]
		} else {
			return ''
		}
	}

	created() {
		this.dates = this.getMonth(new Date())
		this.getData()
		let vm = this
		this.options.shortcuts = [
			{
				text: '当前月',
				value() {
					return vm.getMonth(new Date());
				}
			},
			{
				text: '下个月',
				value() {
					const date = new Date();
					const nextMonth = date.getMonth() + 1
					date.setMonth(nextMonth)
					return vm.getMonth(date)
				}
			},
			{
				text: '下下月',
				value() {
					const date = new Date();
					const nextMonth = date.getMonth() + 2
					date.setMonth(nextMonth)
					return vm.getMonth(date)
				}
			}
		]
	}

	addOne() {
		this.addOrEditData = {
			mode: 'add',
		}
		this.addOrEditShow = true
	}

	// 获取月初月末日期
	getMonth(date: Date) {
		const start = this.formatDate(new Date(date.setDate(1)))
		const currentMonth = date.getMonth()
		const nextMonth = currentMonth + 1
		const nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
		const oneDay = 1000 * 60 * 60 * 24
		const end = this.formatDate(new Date(nextMonthFirstDay.getTime() - oneDay))
		return [start, end]
	}

	options: any = {
		shortcuts: []
	}

	saveSuccess() {
		this.addOrEditShow = false
		this.getData()
	}

	async getData() {
		this.loading = true
		this.showCheck = false
		this.showCancel = false
		let res = await GetDlyOvertime({
			StartDate: this.formatDate(this.dates[0]),
			EndDate: this.formatDate(this.dates[1])
		})
		this.data = res.objects
		this.data.forEach((item: any) => {
			item._disabled = false
		})

		this.loading = false
		this.selectRow = []
		this.columns = Object.assign([], this.columns)
	}

	get cardHeight() {
		return window.innerHeight - 200
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/roomManage/overtime/index.vue